export const fireBaseUrl =
  "https://xpense-ai-default-rtdb.asia-southeast1.firebasedatabase.app";

export const expenseCategories = [
  {
    id: "bill",
    name: "Bill",
    HTMLname: "receipt_long",
  },
  {
    id: "car",
    name: "Car",
    HTMLname: "directions_car",
  },
  {
    id: "clothing",
    name: "Clothing",
    HTMLname: "styler",
  },
  {
    id: "education",
    name: "Education",
    HTMLname: "school",
  },
  {
    id: "entertainment",
    name: "Entertainment",
    HTMLname: "confirmation_number",
  },
  {
    id: "food",
    name: "Food",
    HTMLname: "restaurant",
  },
  {
    id: "health",
    name: "Health",
    HTMLname: "ecg_heart",
  },
  {
    id: "home",
    name: "Home",
    HTMLname: "house",
  },
  {
    id: "insurance",
    name: "Insurance",
    HTMLname: "health_and_safety",
  },
  {
    id: "shopping",
    name: "Shopping",
    HTMLname: "shopping_cart",
  },
  {
    id: "tax",
    name: "Tax",
    HTMLname: "account_balance",
  },
  {
    id: "phone",
    name: "Phone",
    HTMLname: "phone_iphone",
  },
  {
    id: "transport",
    name: "Transport",
    HTMLname: "commute",
  },
  {
    id: "other",
    name: "Other",
    HTMLname: "category",
  },
];

export const incomeCategories = [
  {
    id: "grants",
    name: "Grants",
    HTMLname: "redeem",
  },
  {
    id: "refund",
    name: "Refund",
    HTMLname: "currency_exchange",
  },
  {
    id: "rental",
    name: "Rental",
    HTMLname: "real_estate_agent",
  },
  {
    id: "salary",
    name: "Salary",
    HTMLname: "add_card",
  },
  {
    id: "sale",
    name: "Sale",
    HTMLname: "sell",
  },
  {
    id: "other",
    name: "Other",
    HTMLname: "category",
  },
];

export const allColors = [
  "#ff8811",
  "#f3de2c",
  "#7cb518",
  "#5c8001",
  "#fbb02d",
  "#f94144",
  "#f3722c",
  "#f8961e",
  "#f9844a",
  "#f9c74f",
  "#90be6d",
  "#43aa8b",
  "#4d908e",
  "#577590",
  "#277da1",
];
